import React, { FC, PropsWithChildren, useRef } from 'react';
import styled from '@emotion/styled';
import { observer } from 'mobx-react';
import Footer from '@app/components/Footer';
import BackeeMode from '@backee/backeeMode';
import useScrollTopOnLocationChange from '@app/hooks/useScrollTopOnLocationChange';
import useInfraStores from '@app/hooks/useInfraStores';
import Sidebar from '@app/components/sidebar/Sidebar';
import AuthenticationProvider from '@app/login/AuthenticationProvider';

const BackeeAppContent: FC<PropsWithChildren> = observer((props) => {
  const { userStore } = useInfraStores<BackeeMode>();
  const appContentContainerRef = useRef<HTMLDivElement | null>(null);
  useScrollTopOnLocationChange(appContentContainerRef);

  return (
    <AuthenticationProvider>
      <PageLayout>
        <StyledSidebar />
        <ContentLayout id='appContentContainer' data-testid='app-content-container' ref={appContentContainerRef}>
          <ContentContainer id='main' key={userStore.selectedOrganization?.id}>
            {props.children}
          </ContentContainer>
          <StyledFooter />
        </ContentLayout>
      </PageLayout>
    </AuthenticationProvider>
  );
});

export default BackeeAppContent;

const ContentLayout = styled.main`
  overflow: auto;
  overflow-y: scroll;
  padding-bottom: 32px;

  // Borrowed from antd's Layout
  display: flex;
  flex: auto;
  flex-direction: column;
  min-height: 0;
`;

const ContentContainer = styled.div`
  padding-bottom: 32px;
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const StyledSidebar = styled(Sidebar)`
  flex: 0 0 auto;
  width: 220px;
`;

const StyledFooter = styled(Footer)`
  flex: 0 0 auto;
  text-align: center;
`;

const PageLayout = styled.div`
  display: flex;
  flex: auto;
  flex-direction: row;

  height: 100vh;
  min-height: 0;
`;
